import {
  ProductFeatureResponse,
  ProductInformationResponse,
} from 'services/api/responses/responseTypes';
import type { IProductFeature } from './iProductFeature';
import type { IProductInformation } from './iProductInformation';
import type { IProductLicenseInfo } from './iProductLicenseInfo';
import ProductFeature from './productFeature';
import ProductLicenseInfo from './productLicenseInfo';
import { ProductPriceType, stringToProductPriceType } from './productPriceType';
import { ProductType, stringToProductType } from './productType';

export default class ProductInformation implements IProductInformation {
  title: string;

  subtitle: string;

  description: string;

  focused: boolean;

  index: number;

  features: Array<IProductFeature>;

  priceType: ProductPriceType;

  productType: ProductType;

  licenseInfo: IProductLicenseInfo;

  constructor(data: ProductInformationResponse) {
    this.title = data.title;
    this.subtitle = data.subtitle;
    this.description = data.description;
    this.focused = data.focused;
    this.index = data.index;
    this.priceType = stringToProductPriceType(data.price);
    this.productType = stringToProductType(data.productType);
    this.features = data.features.map(
      (featureData: ProductFeatureResponse) => new ProductFeature(featureData)
    );
    this.licenseInfo = new ProductLicenseInfo(data.licenseInfo);
  }
}
